goog.provide('yext.location.DateTimeRangeModel');
goog.provide('yext.location.DateTimeRange');

goog.require('yext');
goog.require('yext.localization');
goog.require('yext.location.DateTimeModel');
goog.require('yext.location.DateTime');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.time');
goog.require('yext.location.helpers');

/**
 * Model for the date time range field, which contains start/end date time
 *
 * @param {yext.location.DateTimeModel} start The start DateTimeModel
 * @param {yext.location.DateTimeModel} end The end DateTimeModel
 * @param {boolean} True if the field is indeterminate
 *
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
yext.location.DateTimeRangeModel = function(start, end, indeterminate) {
  this.start = start;
  this.end = end;
  this.indeterminate = indeterminate;
};

/**
 * Update the indeterminate flag on the model
 *
 * @param {boolean} indeterminate The updated value
 */
yext.location.DateTimeRangeModel.prototype.updateIndeterminate = function(indeterminate) {
  if (yext.isBoolean(indeterminate) && indeterminate !== this.indeterminate) {
    this.indeterminate = indeterminate;
    this.message('updated');
  }
};

/**
 * Trigger a message on the DateTimeRangeModel
 *
 * @param {string} message Message to trigger
 */
yext.location.DateTimeRangeModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.DateTimeRange = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = this.$ctx.find('.js-field-value');
  this.$start = $ctx.find('.js-start-date-time');
  this.$startDate = this.$start.find('.js-date-input');
  this.$startTime = this.$start.find('.js-time-input');
  this.$end = $ctx.find('.js-end-date-time');
  this.$endDate = this.$end.find('.js-date-input');
  this.$endTime = this.$end.find('.js-time-input');
  this.$indeterminateMsg = $ctx.find('.js-indeterminate-message');

  this.startDateTime = new yext.location.DateTime(this.$start);
  this.endDateTime = new yext.location.DateTime(this.$end);
  this.timestamp = this.$ctx.data('timestamp');

  this.parseDataFromDOM();
  this.storeValue();
  this.setFieldValue();
  this.bindResetAll();
  this.bindUpdates();
};

/**
 * Parse the initial data from the DOM
 */
yext.location.DateTimeRange.prototype.parseDataFromDOM = function() {
  var indeterminate = this.$ctx.data('indeterminate');
  this.model = new yext.location.DateTimeRangeModel(this.startDateTime.model, this.endDateTime.model, indeterminate);
};

/**
 * Store the state for use in reset
 */
yext.location.DateTimeRange.prototype.storeValue = function() {
  this.storedModel = new yext.location.DateTimeRangeModel(
    this.startDateTime.model.copy(),
    this.endDateTime.model.copy(),
    this.model.indeterminate);
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.location.DateTimeRange.prototype.setFieldValue = function() {
  this.$fieldValue.val(this.getJSONData());
};

/**
 * Bind the reset link in bulk edit mode
 */
yext.location.DateTimeRange.prototype.bindResetAll = function() {
  var self = this;

  this.$ctx.find('.js-reset-all-date-time-range').click(function() {
    self.model.start.update({
      date: '',
      time: '',
    });
    self.model.end.update({
      date: '',
      time: '',
    });
    self.model.updateIndeterminate(false);
  });
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.DateTimeRange.prototype.bindUpdates = function() {
  var self = this;

  $(this.startDateTime.model).on('updated', function() {
    self.model.start = this;
    self.model.message('updated');

    if (self.model.start.date && self.model.end.isEmpty()) {
      self.model.end.update(self.model.start);
    }
  });

  $(this.endDateTime.model).on('updated', function() {
    self.model.end = this;
    self.model.message('updated');

    if (self.model.end.date && self.model.start.isEmpty()) {
      self.model.start.update(self.model.end);
    }
  });

  $(this.model).on('updated', function() {
    self.render();
    self.setFieldValue();
    self.message('updated');
  });
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} message Message to trigger
 */
yext.location.DateTimeRange.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the field to a stored state
 */
yext.location.DateTimeRange.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the model data
 *
 * @param {!Object} field Field data
 */
yext.location.DateTimeRange.prototype.set = function(field) {
  this.startDateTime.set(field.start);
  this.endDateTime.set(field.end);
  this.model.indeterminate = !!field.indeterminate;

  if (field.timestamp) {
    this.timestamp = field.timestamp;
  }

  this.model.message('updated');
};

/**
 * Render the current state of the model
 */
yext.location.DateTimeRange.prototype.render = function() {
  this.$indeterminateMsg.toggle(this.model.indeterminate);
  this.$start.toggle(!this.model.indeterminate);
  this.$end.toggle(!this.model.indeterminate);
};

/**
 * Check if the field is empty
 *
 * @return boolean True if field is empty
 */
yext.location.DateTimeRange.prototype.isEmpty = function() {
  return this.model.start.isEmpty() && this.model.end.isEmpty();
};

/**
 * Get the display value for the field
 *
 * @return {string} html string
 */
yext.location.DateTimeRange.prototype.getDisplayValue = function() {
  if (this.model.indeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    return this.$ctx.find('.js-range-view-template').html()
      .replace('#START_DATE', this.model.start.date)
      .replace('#START_TIME', this.model.start.time)
      .replace('#END_DATE', this.model.end.date)
      .replace('#END_TIME', this.model.end.time);
  }
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.DateTimeRange.prototype.getJSONData = function() {
  var data = {
    'start': this.model.start.getDataForExport(),
    'end': this.model.end.getDataForExport(),
    'timestamp': this.timestamp,
  };
  return yext.JSON.stringify(data);
};
